import * as React from "react";
import { Trans } from "react-i18next";
import { ExperienceTransactionRewardedAdDetailsFragmentFragment } from "../../../hooks/useXPTransactions/graphql/XPTransactionsFragment.generated";

export const ExperienceTransactionRewardedAdDetails = ({
  details,
  earnedXP,
  totalXP,
}: {
  details: ExperienceTransactionRewardedAdDetailsFragmentFragment;
  earnedXP: number;
  totalXP: number;
}) => {
  return (
    <Trans
      i18nKey="xp_transaction.ExperienceTransactionRewardedAdDetails"
      components={{
        xp: <span className="font-bold" />,
        total: <span className="font-bold" />,
      }}
      values={{ xp: earnedXP, total: totalXP }}
    />
  );
};
